import { FrontMeta } from "services/pool/app";
import { RuntimeProps } from "views";

export enum TModuleType {
	TCollections = "TCollections",
	TMostPopular = "TMostPopular",
	THotCategories = "THotCategories",
	TBanner = "TBanner",
	TFlash = "TFlash",
	TCategory = "TCategory",
	TSwiper = "TSwiper",
	TQuickNav = "TQuickNav",
	THotKeywords = "THotKeywords",
	THotList = "THotList",
	TProductRecommend = "TProductRecommend",
	TCategoryExtension = "TCategoryExtension",
	TTopBanner = "TTopBanner",
	TMagicBannerType = "TMagicBannerType",
	TMultiProductModuleType = "TMultiProductModuleType",
	TPageTitleLineType = "TPageTitleLineType",
	TNavIcons = "TNavIcons",
	TRichText = "TRichText",
	TCountdownBanner = "TCountdownBanner",
	TMagicVoucher = "TMagicVoucher",
	TDiscount = "TDiscount",
	TMultiFlash = "TMultiFlash",
	TSideBanner = "TSideBanner",
	TMultiHeroDeal = "TMultiHeroDeal",
	TStickBotomTab = "TStickBotomTab",
	TLogo = "TLogo",
	THomeBanner = "THomeBanner",
	TNavIconGroups = "TNavIconGroups",
	TMultiCollection = "TMultiCollection",
	TMultiRecPurTab = "TMultiRecPurTab",
	TBottomIcons = "TBottomIcons",
	TShakeIcon = "TShakeIcon",
	TTimelineBanner = "TTimelineBanner",
	TMultiCollectionTwo = "TMultiCollectionTwo",
	TNoLoginBanner = "TNoLoginBanner",
	TFlashArea = "TFlashArea",
	TMillion = "TMillion",
	TMagicBannerTwo = "TMagicBannerTwo",
	TCoupon="TCoupon",
	TAll = "TAll"
}


export interface CommonProps {
	id: string;
}

export const transformMetaForApi = (runtime: Partial<RuntimeProps>): FrontMeta => {
	const { countryCode, languageCode, platform, currency } = runtime;
	return {
		catalog: countryCode,
		lang: languageCode,
		client: platform,
		priceSymbol: currency,
	};
};
